import React from "react";

const ChatCloseModal = ({
	chatType,
	setShowChat,
	setAreYouSure,
	setMessages,
}) => {
	return (
		<div className="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center p-3 bg-[rgba(0,0,0,0.7)] backdrop-blur-sm font-saira">
			<div>
				<div className="flex justify-center">
					<p className="text-xs font-thin leading-5 tracking-wider text-center text-white w-[90%]">
						{`We hope the ${chatType} was able to assist with your inquiries.`}
						<br />
						<br />
						If you'd like to continue the conversation about your inquiries, you
						can book a 30-minute call with our team using the 'Book a Free Call'
						button.
						<br />
						<br /> We’re excited about the possibility of working with you!
						<br />
						<br />
						<strong className="text-sm font-semibold text-teal">{`Close ${chatType} session ?`}</strong>
					</p>
				</div>
				<div className="flex items-center justify-center gap-2 mt-3">
					<p
						className="px-3 text-black bg-white cursor-pointer rounded-xl"
						onClick={() => {
							setShowChat(false);
							setAreYouSure(false);
							sessionStorage.removeItem("chatMessages");
							setMessages([]);
						}}>
						Yes
					</p>
					<p
						className="px-3 text-white border-[0.5px] border-white rounded-xl cursor-pointer"
						onClick={() => setAreYouSure(false)}>
						No
					</p>
				</div>
			</div>
		</div>
	);
};

export default ChatCloseModal;
